import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { GroupActivity } from "@/@types/esus/GroupActivity";

type IndicatorEmultiM1GroupActivitiesHistoryItemProps = {
	groupActivityCitizen: GroupActivity;
};

export function IndicatorEmultiM1GroupActivitiesHistoryItem({
	groupActivityCitizen,
}: Readonly<IndicatorEmultiM1GroupActivitiesHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{groupActivityCitizen.healthTeam?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{groupActivityCitizen.healthUnit?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{groupActivityCitizen.professional?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{groupActivityCitizen.cbo?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
		</>
	);
}
